import { render, staticRenderFns } from "./InviteWorkspaceMembersModal.vue?vue&type=template&id=cfbcf2a6&scoped=true"
import script from "./InviteWorkspaceMembersModal.vue?vue&type=script&lang=js"
export * from "./InviteWorkspaceMembersModal.vue?vue&type=script&lang=js"
import style0 from "./InviteWorkspaceMembersModal.vue?vue&type=style&index=0&id=cfbcf2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbcf2a6",
  null
  
)

export default component.exports